import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  response: "",
  receivingResponse: false,
  sendMessage: null,
}

const socketStore = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setReceivingResponse: (state, action) => ({
      ...state,
      receivingResponse: action.payload,
    }),
    appendResponseText: (state, action) => ({
      ...state,
      response: state.response + action.payload,
    }),
    clearResponse: (state) => ({
      ...state,
      response: "",
    }),
    setSendMessage: (state, action) => ({
      ...state,
      sendMessage: action.payload,
    }),
    resetSocketState: () => initialState,
  },
})

export const { setReceivingResponse, appendResponseText, clearResponse, setSendMessage, resetSocketState } =
  socketStore.actions

export default socketStore.reducer
